import { ganIndex, zhiIndex } from './constants';
import { LIU_QIN_RELATION, liuQinOfZhi } from './liuqin';
/** 九宗门课体 → 吉凶倾向与释义 */
const KE_TI_JUDGE = {
    元首: { luck: 1, text: '元首课上下顺理、尊卑有序，为正大光明之象，谋事循正途可成' },
    重审: { luck: 0, text: '重审课以下贼上、事由下起，宜反复详审，勿遽下决断' },
    比用: { luck: 0, text: '比用（知一）课去留难定，须择其与己相合者从之' },
    知一: { luck: 0, text: '比用（知一）课去留难定，须择其与己相合者从之' },
    涉害: { luck: -1, text: '涉害课事涉艰险、历经周折，须忍苦耐劳方可脱困' },
    遥克: { luck: -1, text: '蒿矢弹射皆属遥克，事隔一层、力有不及，须借人成事' },
    昴星: { luck: -2, text: '昴星课进退迟疑、事多反覆，非静守不能免咎' },
    别责: { luck: -1, text: '别责课四课不全，事不由己，须依附他人之力方能有成' },
    八专: { luck: -2, text: '八专课干支同位、事多重叠纠缠，宜独断独行而防内部生变' },
    伏吟: { luck: -2, text: '伏吟课天地不动、事多停滞，只宜守常待时，动则无功' },
    返吟: { luck: -2, text: '返吟课天地相冲、反覆动摇，事多更变，宜缓图不宜急进' },
    贼克: { luck: 0, text: '贼克成课，事情有可乘之机，顺其克应之理行之' },
};
/** 单个要点加权汇总 */
function scoreOf(points) {
    return points.reduce((sum, p) => sum + p.weight, 0);
}
/** 分数 → 评级 */
function rate(score) {
    if (score >= 6)
        return '吉';
    if (score >= 3)
        return '中吉';
    if (score > -3)
        return '平';
    if (score > -6)
        return '小凶';
    return '凶';
}
/**
 * 断课：生成结构化要点 + 综合断语。
 */
export function interpret(input) {
    const { siZhuText, dayGan, dayZhi, zhanShi, keTi, ke, chuan, kongWang, shenSha, benMing } = input;
    const points = [];
    // ── 1. 课体 ──
    const judge = KE_TI_JUDGE[keTi.name.replace(/课（.*）$/, '').replace(/课$/, '')] ??
        KE_TI_JUDGE[keTi.school] ?? { luck: 0, text: `${keTi.name}：${keTi.reason}` };
    points.push({
        category: '课体',
        level: judge.luck > 0 ? '吉' : judge.luck < 0 ? '凶' : '平',
        weight: judge.luck * 2,
        text: `${keTi.name} — ${judge.text}`,
    });
    for (const extra of keTi.extras) {
        const ex = EXTRA_JUDGE[extra];
        if (!ex)
            continue;
        points.push({
            category: '课体',
            level: ex.luck > 0 ? '吉' : ex.luck < 0 ? '凶' : '平',
            weight: ex.luck,
            text: `三传${extra} — ${ex.text}`,
        });
    }
    // ── 2. 三传天将 ──
    for (const c of chuan) {
        const luck = JIANG_LUCK[c.tianJiang] ?? 0;
        if (luck === 0)
            continue;
        points.push({
            category: '天将',
            level: luck > 0 ? '吉' : '凶',
            weight: luck,
            text: `${c.position}${c.zhi}乘${c.tianJiang} — ${JIANG_TEXT[c.tianJiang] ?? ''}`,
        });
    }
    // ── 3. 三传六亲 ──
    const qinCount = {};
    for (const c of chuan)
        qinCount[c.liuQin] = (qinCount[c.liuQin] ?? 0) + 1;
    const qinEntries = Object.entries(qinCount).sort((a, b) => b[1] - a[1]);
    for (const [qin, n] of qinEntries) {
        const rule = QIN_JUDGE[qin];
        if (!rule)
            continue;
        points.push({
            category: '六亲',
            level: rule.luck > 0 ? '吉' : rule.luck < 0 ? '凶' : '平',
            weight: rule.luck * n,
            text: `三传中${qin}居${n}位 — ${rule.text}`,
        });
    }
    // 初传六亲为主事之应
    const first = chuan[0];
    if (first) {
        const rule = QIN_FIRST_JUDGE[first.liuQin];
        if (rule) {
            points.push({
                category: '六亲',
                level: rule.luck > 0 ? '吉' : rule.luck < 0 ? '凶' : '平',
                weight: rule.luck,
                text: `初传${first.zhi}为${first.liuQin}（发用之始） — ${rule.text}`,
            });
        }
    }
    // ── 4. 日干与日支（干支关系） ──
    {
        const gi = ganIndex(dayGan);
        const zi = zhiIndex(dayZhi);
        if (gi >= 0 && zi >= 0) {
            const qin = liuQinOfZhi(gi, zi);
            const luck = QIN_JUDGE[qin]?.luck ?? 0;
            points.push({
                category: '六亲',
                level: luck > 0 ? '吉' : luck < 0 ? '凶' : '平',
                weight: luck,
                text: `日支${dayZhi}为日干${dayGan}之${qin} — ${LIU_QIN_RELATION[qin]}`,
            });
        }
    }
    // ── 5. 空亡 ──
    if (kongWang.length === 2) {
        const kongChuan = chuan.filter((c) => c.kong);
        if (kongChuan.length === 3) {
            points.push({
                category: '空亡',
                level: '凶',
                weight: -3,
                text: `三传尽落旬空（${kongWang.join('')}）— 全无实据，谋事终归落空，宜止不宜行`,
            });
        }
        else if (kongChuan.length > 0) {
            points.push({
                category: '空亡',
                level: '凶',
                weight: -kongChuan.length,
                text: `${kongChuan.map((c) => c.position + c.zhi).join('、')}落旬空（${kongWang.join('')}）— 所应之事虚而不实、迟而无果`,
            });
        }
        if (chuan[0]?.kong) {
            points.push({
                category: '空亡',
                level: '凶',
                weight: -2,
                text: '初传落空，发用无力 — 事情启动即虚，谋为多有不遂',
            });
        }
        const kongKe = ke.filter((k) => k.kong);
        if (kongKe.length > 0) {
            points.push({
                category: '空亡',
                level: '凶',
                weight: -1,
                text: `第${kongKe.map((k) => k.index).join('、')}课上神落空 — 所主之事有名无实`,
            });
        }
    }
    // ── 6. 神煞命中 ──
    const chuanZhi = chuan.map((c) => c.zhi);
    const keZhi = ke.map((k) => k.shang);
    for (const s of shenSha) {
        const inChuan = chuanZhi.includes(s.value);
        const inKe = keZhi.includes(s.value);
        if (!inChuan && !inKe)
            continue;
        points.push({
            category: '神煞',
            level: s.luck > 0 ? '吉' : s.luck < 0 ? '凶' : '平',
            weight: s.luck * (inChuan ? 1.5 : 1),
            text: `${s.name}（${s.basis}见${s.value}）${inChuan ? '入三传' : '临四课'} — ${s.desc}`,
        });
    }
    // ── 7. 本命 / 行年（可选输入：提供出生年份与性别时才有） ──
    if (benMing) {
        const jiangLuck = JIANG_LUCK[benMing.xingNianJiang] ?? 0;
        if (jiangLuck !== 0) {
            points.push({
                category: '行年',
                level: jiangLuck > 0 ? '吉' : '凶',
                weight: jiangLuck,
                text: `行年${benMing.xingNian}，上神${benMing.xingNianShangShen}乘${benMing.xingNianJiang} — ${JIANG_TEXT[benMing.xingNianJiang] ?? ''}`,
            });
        }
        if (benMing.xingNianKong) {
            points.push({
                category: '行年',
                level: '凶',
                weight: -1,
                text: `行年上神${benMing.xingNianShangShen}落旬空 — 主这一年谋事多虚耗，宜守不宜进`,
            });
        }
        const qinRule = QIN_JUDGE[benMing.xingNianLiuQin];
        if (qinRule && qinRule.luck !== 0) {
            points.push({
                category: '行年',
                level: qinRule.luck > 0 ? '吉' : '凶',
                weight: qinRule.luck,
                text: `行年上神为日干之${benMing.xingNianLiuQin} — ${qinRule.text}`,
            });
        }
    }
    // ── 汇总 ──
    const score = scoreOf(points);
    const fortune = rate(score);
    const sorted = [...points].sort((a, b) => Math.abs(b.weight) - Math.abs(a.weight) || (b.weight - a.weight));
    const good = sorted.filter((p) => p.weight > 0).slice(0, 3);
    const bad = sorted.filter((p) => p.weight < 0).slice(0, 3);
    const summaryText = `${keTi.name} · ${fortune}`;
    const overall = [
        `课得「${siZhuText}」，占时${zhanShi}，${keTi.name}。`,
        judge.text + '。',
        good.length > 0 ? `可倚者：${good.map((p) => p.text.split(' — ')[0]).join('；')}。` : '',
        bad.length > 0 ? `宜防者：${bad.map((p) => p.text.split(' — ')[0]).join('；')}。` : '',
        FORTUNE_ADVICE[fortune],
    ]
        .filter(Boolean)
        .join('');
    return { fortune, score, summary: summaryText, overall, points: sorted };
}
// ════════════════════════════════════════════════════════════
// 文案与权重表
// ════════════════════════════════════════════════════════════
const EXTRA_JUDGE = {
    进连茹: { luck: 2, text: '三传相连而进，步步相续，事有次第、渐入佳境' },
    退连茹: { luck: -2, text: '三传相连而退，事事退缩，宜守旧不宜图新' },
    三合课: { luck: 2, text: '三传结为三合局，众力相扶、内外相应，事得圆满' },
    递生: { luck: 2, text: '三传递相生，吉事相因、源源不绝' },
    递克: { luck: -2, text: '三传递相克，凶事相因、层层逼迫' },
    三传俱阳: { luck: 1, text: '三传纯阳，主光明外显、事情易于显扬' },
    三传俱阴: { luck: -1, text: '三传纯阴，主暗昧隐伏、事情难以显扬' },
};
const JIANG_LUCK = {
    贵人: 2, 螣蛇: -2, 朱雀: -1, 六合: 1, 勾陈: -1, 青龙: 2,
    天空: -2, 白虎: -2, 太常: 1, 玄武: -2, 太阴: 1, 天后: 1,
};
const JIANG_TEXT = {
    贵人: '尊贵扶助、逢难得解，主贵人提携',
    螣蛇: '虚惊怪异、缠绕不安，主虚诈惊恐',
    朱雀: '文书口舌、信息是非，主言语消息之争',
    六合: '和合成就、媒合交易，主合作婚姻之喜',
    勾陈: '勾连迟滞、田土争讼，主拖延纠缠',
    青龙: '喜庆财帛、进财升迁，主财喜之事',
    天空: '虚妄落空、欺诳不实，主虚耗无成',
    白虎: '凶伤疾病、道路血腥，主伤病急迫',
    太常: '衣食宴乐、平常和顺，主平安衣食',
    玄武: '盗贼暗昧、遗失逃亡，主暗中损失',
    太阴: '阴私暗助、女子之事，主暗中相助',
    天后: '妇女恩泽、婚姻孕育，主恩泽婚育',
};
const QIN_JUDGE = {
    父母: { luck: 1, text: '主长辈庇护、文书房屋之事可成' },
    兄弟: { luck: 0, text: '主同辈竞争、分夺财利，须防口舌' },
    子孙: { luck: 1, text: '主平安喜悦、解厄降福，为福德之神' },
    妻财: { luck: 1, text: '主财物进益、经营有成，可得实利' },
    官鬼: { luck: -2, text: '主官非忧患、疾病阻碍，多有克身之事' },
};
const QIN_FIRST_JUDGE = {
    父母: { luck: 1, text: '事发于长辈文书之事，宜求庇于上' },
    兄弟: { luck: 0, text: '事发于同辈之交，利于协力、忌于分争' },
    子孙: { luck: 1, text: '事发于喜悦安顺，事多顺遂解厄' },
    妻财: { luck: 1, text: '事发于财利经营，所求多为财物之事' },
    官鬼: { luck: -2, text: '事发于忧患逼迫，多因外压或病讼而起' },
};
/** 评级 → 行动建议 */
const FORTUNE_ADVICE = {
    吉: '（课象大吉）时机已至，宜果断专行，勿犹豫失机。',
    中吉: '（课象偏吉）大势可成，宜循正途稳进，注意细节防小失。',
    平: '（课象平常）吉凶相半，宜守中道、量力而行，不宜强求。',
    小凶: '（课象偏凶）多有阻碍，宜暂缓图之、先求自保，待时而动。',
    凶: '（课象凶险）诸事不宜，宜止不宜行，静守祈福、切勿妄动。',
};
//# sourceMappingURL=interpret.js.map